import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import SizeDependedBlock from 'components/SizeDependedBlock';

import CommonPropTypes from 'utils/propTypes/common';

import Item from './components/Item';

import styles from './styles.module.scss';

const Breadcrumbs = ({ items, currentPath, theme }) => {
	const preparedItems = items.map(({ path, ...item }) => ({
		...item,
		path: currentPath && currentPath === path ? null : path
	}));
	const mobileItem = _([...preparedItems].reverse()).find(({ path }) => !!path);

	return (
		<div className={styles.breadcrumbs}>
			<SizeDependedBlock>
				<Item title={mobileItem.title} path={mobileItem.path} theme={theme} />
				{_(preparedItems).map((item) => (
					<Item
						key={item.title}
						title={item.title}
						path={item.path}
						theme={theme}
					/>
				))}
			</SizeDependedBlock>
		</div>
	);
};

Breadcrumbs.propTypes = {
	items: CommonPropTypes.breadcrumbs,
	currentPath: PropTypes.string,
	theme: PropTypes.oneOf(['white'])
};

Breadcrumbs.defaultProps = {
	items: []
};

export default Breadcrumbs;
